// import axios from "../lib/axios";
// import axios2 from "axios";
import axios from "axios";
import { API_KEY, API_URL } from "../config";

const url = process.env.REACT_APP_API;

export const uploadFile = async (file) => {
  let formData = new FormData();
  try {
    formData.append("file", file);
    const response = await axios.post(
      //"https://www.powerlego.com/ApiGateway/v1/bill_reader",
      // "https://dev.powerlego.com/ApiGateway/v1/bill_reader",
      //`${url}/bill_reader/upload-pdf`,
      `${API_URL}v1/bill_reader`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${API_KEY}`,
        },
      }
    );

    return response.data;
  } catch (err) {
    return "ERROR";
  }
};

export const createUser = async (
  meter_id,
  address,
  zipcode,
  street,
  city,
  state,
  esiid,
  company,
  puct
) => {
  try {
    const response = await axios.post(
      `${url}/bill_reader/create`,
      {
        meter_id: meter_id,
        address: address,
        zipcode: zipcode,
        street: street,
        city: city,
        state: state,
        esiid: esiid,
        company: company,
        puct: puct,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (err) {
    return "ERROR";
  }
};

export const optimalPlan = async (
  Zip,
  PromoCode,
  CustomerTypeID,
  rate,
  usage
) => {
  try {
    const response = await axios.post(
      `${url}/bill_reader/findOptimalPlan`,
      {
        Zip: Zip,
        PromoCode: PromoCode,
        CustomerTypeID: CustomerTypeID,
        rate: rate,
        usage: usage,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (err) {
    return "ERROR";
  }
};


export const postToHubSpot = async(firstName, lastName, email, status) =>{

  const response = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/23498454/9bbfb6b7-8dfc-4662-88b8-65337bda852e`,
    {
        method: 'POST',
        headers: {
            'content-Type': 'application/json'
        },
        body: JSON.stringify({
            fields: [
                {
                    "objectTypeId": "0-1",
                    "name": "abandoned_status",
                    "value": status
                },
                {
                    "objectTypeId": "0-1",
                    "name": "email",
                    "value": email
                },
                {
                    "objectTypeId": "0-1",
                    "name": "firstname",
                    "value": firstName
                },
                {
                    "objectTypeId": "0-1",
                    "name": "lastname",
                    "value": lastName
                }
            ]
        })
    }
  )
return response.json()
}
